
import React  from 'react';
import styled from 'styled-components';


const StyledTotalExtraServicesAmount = styled.div`
  font-size: 16px;
  margin: 20px 0 10px 34px;
`;
const StyledTotalAmount = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-left: 34px;
  margin-bottom: 10px;
`;

const StyledTotalReExposedAmount = styled.div`
  font-size: 16px;
  margin-left: 34px;
  margin-bottom: 10px;
`;

export default function OrderTotalAmount({item}) {
  let totalAmount = 0.0;
  let extraServicesCount = 0;
  let totalExtraServicesAmount = 0.0;
  let totalReExposedAmount = 0.0;
  let totalOwnAmount = 0.0;

  item.points.forEach(point => {
    if (point.is_delete !== true) {
      point.services.forEach(service => {
        totalAmount += service.quantity * service.cost;

        if (service.service) {
          if (service.service.financial_schema === 'RE_EXPOSED') {
            totalReExposedAmount += service.quantity * service.cost;
          }
          else if (service.service.financial_schema === 'OWN') {
            totalOwnAmount += service.quantity * service.cost;
          }
        }
      });
    }
  });

  item.extra_services.forEach(extra_service => {
    if (extra_service.is_delete !== true) {
      extraServicesCount += 1;
      totalAmount += extra_service.quantity * extra_service.cost;
      totalExtraServicesAmount += extra_service.quantity * extra_service.cost;

      if (extra_service.service) {
        if (extra_service.service.financial_schema === 'RE_EXPOSED') {
          totalReExposedAmount += extra_service.quantity * extra_service.cost;
        }
        else if (extra_service.service.financial_schema === 'OWN') {
            totalOwnAmount += extra_service.quantity * extra_service.cost;
          }
      }
    }
  });

  totalExtraServicesAmount = totalExtraServicesAmount.toFixed(2);
  totalReExposedAmount = totalReExposedAmount.toFixed(2);
  totalOwnAmount = totalOwnAmount.toFixed(2);
  totalAmount = totalAmount.toFixed(2);

  return (
    <div className={'mb-40'}>
      <StyledTotalExtraServicesAmount>Дополнительные услуги <strong>{extraServicesCount}</strong>
        {' '}на сумму <strong>{totalExtraServicesAmount} ₽</strong>
      </StyledTotalExtraServicesAmount>

      <StyledTotalAmount>Общая сумма {totalAmount} ₽</StyledTotalAmount>

      <StyledTotalReExposedAmount>
        Из них собственные на сумму <strong>{totalOwnAmount} ₽</strong>
      </StyledTotalReExposedAmount>

      <StyledTotalReExposedAmount>
        Из них перевыставляемые на сумму <strong>{totalReExposedAmount} ₽</strong>
      </StyledTotalReExposedAmount>
    </div>
  )
}
